<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="fill"
      d="M0 8.19926C0.000980377 7.25657 0.375896 6.35277 1.04248 5.68619C1.70906 5.0196 2.61286 4.64469 3.55556 4.6437H6.5037C6.71926 4.63111 10.4756 4.36667 14.0526 1.36667C14.2253 1.2216 14.4359 1.12883 14.6595 1.09927C14.8831 1.06971 15.1106 1.10458 15.3151 1.19979C15.5195 1.295 15.6926 1.44659 15.814 1.63676C15.9353 1.82692 15.9998 2.04776 16 2.27333V14.1252C16 14.3508 15.9355 14.5718 15.8143 14.762C15.693 14.9523 15.5199 15.104 15.3154 15.1993C15.1109 15.2946 14.8834 15.3295 14.6597 15.3C14.436 15.2705 14.2254 15.1777 14.0526 15.0326C11.2548 12.6859 8.34889 12.0133 7.11111 11.8252V14.1748C7.11136 14.3701 7.06334 14.5624 6.97133 14.7347C6.87932 14.907 6.74616 15.0538 6.5837 15.1622L5.76889 15.7052C5.6114 15.8103 5.43101 15.8762 5.24284 15.8972C5.05466 15.9183 4.86418 15.894 4.68733 15.8263C4.51049 15.7586 4.35244 15.6496 4.22641 15.5083C4.10038 15.3669 4.01004 15.1975 3.96296 15.0141L3.09111 11.7281C2.23576 11.6143 1.45083 11.1938 0.882264 10.5447C0.313699 9.89562 0.000180244 9.06215 0 8.19926ZM14.8148 14.12V2.27333C11.6437 4.93333 8.39778 5.60667 7.11111 5.77259V10.623C8.3963 10.7919 11.6415 11.4637 14.8148 14.12ZM5.11111 14.7126V14.7207L5.92593 14.1778V11.7548H4.32593L5.11111 14.7126ZM3.55556 10.5696H5.92593V5.82889H3.55556C2.92689 5.82889 2.32398 6.07862 1.87945 6.52315C1.43492 6.96769 1.18519 7.5706 1.18519 8.19926C1.18519 8.82792 1.43492 9.43083 1.87945 9.87536C2.32398 10.3199 2.92689 10.5696 3.55556 10.5696Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FeedbackIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
